"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GroupsNotificationKey;
(function (GroupsNotificationKey) {
    GroupsNotificationKey["GROUPS_SECTION"] = "social_groups";
    GroupsNotificationKey["GROUP_CREATED"] = "social_groups.social_group_created";
    GroupsNotificationKey["MEMBER_REQUEST"] = "social_groups.social_group_new_member_request";
    GroupsNotificationKey["COMMENT"] = "social_groups.social_group_new_comment";
    GroupsNotificationKey["POST"] = "social_groups.social_group_posts";
    GroupsNotificationKey["REACTION"] = "social_groups.social_group_new_reaction";
})(GroupsNotificationKey = exports.GroupsNotificationKey || (exports.GroupsNotificationKey = {}));
//# sourceMappingURL=GroupsNotificationKey.js.map